import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import NotificationItem from "./NotificationItem";
import NotificationDate from "./NotificationDate";
import BasicLoader from "../UI/Loader/BasicLoader";
import ErrorRetry from "../UI/ErrorRetry";

const Container = styled.ul.attrs({ className: "notifications-list" })`
  max-width: 100vw;
  width: 960px;

  .item .date {
    background: ${props => props.theme.colors.silver};
    padding: 5px 10px;
    text-align: center;
  }
  .item {
    border-bottom: 1px solid;
    border-bottom-color: ${props => props.theme.colors.silver};
    display: flex;
    padding: 6px 10px;
  }
  .item .content {
    margin: 0 0 0 10px;
  }
`;

const NotificationList = ({ notifications, loading, error, onErrorRetry }) => {
  if (error) {
    return <ErrorRetry onRetry={onErrorRetry} />;
  }

  if (loading) {
    return <BasicLoader />;
  }

  return (
    <Container>
      {notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          className="item"
          notification={{
            ...notification,
            createdAt: (
              <NotificationDate
                className="date"
                title={notification.createdAt.toLocaleString()}
              >
                {notification.createdAt}
              </NotificationDate>
            )
          }}
        />
      ))}
    </Container>
  );
};

NotificationList.propTypes = {
  notifications: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
  onErrorRetry: PropTypes.func
};

NotificationList.defaultProps = {
  notifications: []
};

export default NotificationList;
